import type { TagRecord } from "@hydeck/mdt-contracts";
import { createResource } from "solid-js";
import { apiRequest } from "../core/api";
import { currentUser } from "../core/session";
import { CrudCollectionPage } from "./CrudCollectionPage";

export function LegislationPage() {
  const [tags] = createResource(() =>
    apiRequest<TagRecord[]>("/tags", { token: currentUser()?.accessToken }).catch(() => []),
  );
  return (
    <CrudCollectionPage
      label="Legislation"
      endpoint="/legislation"
      icon="nav_legislation"
      canUpdate={false}
      advancedFields={[
        {
          key: "tags",
          label: "Tags",
          type: "select",
          options: (tags() ?? []).map((tag) => ({ value: String(tag.id), label: tag.name })),
        },
        { key: "createdFrom", label: "Date From", type: "datetime-local" },
        { key: "createdTo", label: "Date To", type: "datetime-local" },
      ]}
      createDefaults={{ title: "", description: "" }}
      fields={[
        { key: "title", label: "Title" },
        { key: "description", label: "Document" },
      ]}
      itemTitle={(item) => value(item.title)}
      itemDescription={(item) => value(item.description)}
      itemRightLabel={(item) => date(item.createdAt)}
      prepareWrite={(item) => ({
        title: value(item.title),
        description: value(item.description),
      })}
    />
  );
}

function value(input: unknown): string {
  return typeof input === "string" || typeof input === "number"
    ? String(input)
    : "";
}
function date(input: unknown): string {
  const valueString = value(input);
  return valueString ? new Date(valueString).toLocaleString() : "";
}
